import styled from "styled-components";
import * as h from "../../_themes/helpers";
import { BaseButton } from "../../BaseButton";

export const Wrapper = styled(BaseButton)`
  color: ${({ theme, active }) =>
    active
      ? h.getActiveColor("menuNavButton", "menu.navButton")
      : h.getColor("menuNavButton", "menu.navButton")};

  &:hover {
    color: ${({ theme, active }) =>
      active
        ? h.getActiveColor("menuNavButton", "menu.navButton")
        : h.getHoverColor("menuNavButton", "menu.navButton")};
  }

  &:active {
    color: ${({ theme, active }) =>
      active
        ? h.getActiveColor("menuNavButton", "menu.navButton")
        : h.getPressedColor("menuNavButton", "menu.navButton")};
  }

  &[disabled] {
    color: ${({ theme }) =>
      theme.menuNavButtonDisabled ||
      h.getDisabledColor("menuNavButton", "menu.navButton")};
  }
`;
